import { hasStoredSession } from './stored-session'

// BootSwitch only asks for a root after auth resolves. Start the one this
// session will need now, so it downloads alongside the entry instead of after it.
export const warmSessionRoot = () => {
  const root = hasStoredSession() ? import('../Root') : import('../PublicRoot')

  root.catch(() => undefined)
}
